export default __webpack_public_path__ + "static/media/commonocean-rl-code-example.9f066a58.md";